import React from "react";
import logo from '../../../assets/img/logo.png';
import Typography from '@mui/material/Typography';
import { Box } from "@mui/material";
import { ROUTES_PATH } from "../../../utils/Consts";
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

function HomeLogoUI({
    visible
}) {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row',
            alignItems: 'center',
            gap: { xs: '16px', sm: '24px' },
            padding: { xs: '0 20px', sm: '0' }
        }}>
            {/* Logo a la izquierda */}
            <img 
                src={logo}
                alt="Logo Panadería El Rosal"
                loading="lazy"
                onClick={() => navigate(ROUTES_PATH.HOME)}
                style={{ 
                    cursor: 'pointer',
                    width: isMobile ? '120px' : '150px',
                    height: 'auto'
                }}
            />
            
            {/* Texto a la derecha */}
            {visible && (
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center'
                }}>
                    {/* Solo visible en escritorio */}
                    {!isMobile && (
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand',
                                fontSize: '18px',
                                fontWeight: '500',
                                color: '#d7b547',
                                textTransform: 'uppercase',
                                letterSpacing: '4px',
                                lineHeight: 1.2,
                                marginBottom: '4px',
                                textShadow: '0 0 8px rgba(215, 181, 71, 0.5)'
                            }}>
                            Panadería y Pastelería
                        </Typography>
                    )}
                    <Typography
                        sx={{
                            fontFamily: 'Quicksand',
                            fontSize: { xs: '24px', sm: '32px' },
                            fontWeight: 'bold',
                            color: '#d7b547',
                            textTransform: 'uppercase',
                            letterSpacing: { xs: '4px', sm: '6px' },
                            lineHeight: 1,
                            marginBottom: '6px',
                            textAlign: 'center',
                            textShadow: '0 0 10px rgba(215, 181, 71, 0.6)'
                        }}>
                        EL ROSAL
                    </Typography>
                    <Box sx={{ 
                        width: '100%', 
                        height: '2px', 
                        backgroundColor: '#DC143C',
                        marginBottom: '6px'
                    }} />
                    {/* Solo visible en escritorio */}
                    {!isMobile && (
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand',
                                fontSize: '15px',
                                fontWeight: '400',
                                color: '#d7b547',
                                lineHeight: 1.2,
                                textAlign: 'center',
                                textShadow: '0 0 8px rgba(215, 181, 71, 0.5)'
                            }}>
                            Lo mejor en Pan y Ponques
                        </Typography>
                    )}
                </Box>
            )}
        </Box>
    );
}

export { HomeLogoUI }